export default "__VITE_PUBLIC_ASSET__d5d4ebbb__"